import { Injectable } from '@angular/core';
import { SpaContext } from '../../../Classes/spacontext';
import { VisibaApiHttp } from '../../../Classes/visibaHttp.class';
import { ProductPrice } from './Models/ProductPrice';

@Injectable()
export class RateService {
	readonly baseUri = '/api/Client/v2/Rate';

	constructor(private http: VisibaApiHttp, private spaContext: SpaContext) {}

	public getMessagingConversationPrice() {
		return this.http.getTyped<ProductPrice>(
			`${this.baseUri}/${this.spaContext.unitConfig.ReceptionId}/GetMessagingConversationPrice`,
		);
	}
}
